export const VIEW_MODES = ['default', 'record-my-name'] as const;
export type View = (typeof VIEW_MODES)[number];

export function parseView(raw: unknown): View {
  if (typeof raw !== 'string') return 'default';
  return (VIEW_MODES as readonly string[]).includes(raw) ? (raw as View) : 'default';
}
